import * as React from 'react';
import { DefaultLayout, INavItem } from "./index";

interface IUnrestrictedLayoutProps {
    subMenuItems?: INavItem[]; 
}

class UnrestrictedLayout extends React.PureComponent<IUnrestrictedLayoutProps, any> {

    constructor(props) {
        super(props);
    }

    componentWillMount() {
    }

    componentWillReceiveProps(nextProps: any) {
    }

    componentDidUpdate(prevProps: any) {

    }

    componentWillUpdate(nextProps: any) {
    }

    componentWillUnmount() {
    }

    render() {

        return (
            <DefaultLayout>
                <div>
                    {this.props.children}
                </div>
            </DefaultLayout>
        ) 
        
    }
}

export default UnrestrictedLayout;